import React from 'react'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import styles from './assets/styles/styles.module.css'
import { useFavicon } from './hooks/useFavicon'
import { HeaderSection } from './components/HeaderSection'
import { RatingContext } from './utils/RatingContext'
import { META_ICONS_CDN_BASE_URL, META_ICONS_MANIFEST } from '@porsche-design-system/assets';
import { FooterSection } from './components/FooterSection'
import { RatingSection } from './components/RatingSection'

function getRandomInt({ min, max }: Rating.RandomNumber) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
} 

const App = () => {
  const params: Rating.QueryParams = queryString.parse(useLocation().search);
  const metaIconsUrl = `${META_ICONS_CDN_BASE_URL}/${META_ICONS_MANIFEST.favicon.favicon_32x32}`;
  const showDevHint = process.env.REACT_APP_SHOW_DEV_HINT === 'true';
  const devHintLabel = process.env.REACT_APP_DEV_HINT_LABEL || 'Develop';

  const background = React.useMemo(() => {
    if (params?.background !== undefined) return Number(params.background);
    return getRandomInt({ min: 0, max: 6 });
  }, [params?.background]);

  const backgroundImageClass = styles['background' + background];

  // Build Context for Rating App
  const language: string = params?.lang || 'de';
  const configId: string = params?.configId || '';
  const apiKey: string = params?.apiKey || '';
  const isFrame: boolean = params?.frame || false;
  const variant: string = params?.variant || '';
  const appName: string = params?.appName || '';
  const isTest: boolean = params?.test || false;

  const [loading, setLoading] = React.useState(false);
  const [preCheck, setPreCheck] = React.useState(configId !== '');
  const [formCompleted, setFormCompleted] = React.useState(configId === '');
  const [formError, setFormError] = React.useState(false);
  const [requestError, setRequestError] = React.useState(configId === '');
  const [guidedToggle, setGuidedToggle] = React.useState(false);
  const [rating, setRating] = React.useState(0);
  const [errorCode, setErrorCode] = React.useState('301');

  useFavicon(metaIconsUrl)

  return (
    <RatingContext.Provider value={{ language, configId, apiKey, isFrame, variant, appName, isTest, loading, setLoading, preCheck, setPreCheck, formCompleted, setFormCompleted, formError, setFormError, requestError, setRequestError, guidedToggle, setGuidedToggle, rating, setRating, errorCode, setErrorCode}}>
      <div className={clsx({ [styles.frame]: isFrame, [styles.standalone]: !isFrame, [backgroundImageClass]: !isFrame })}>
        {showDevHint && (
          <div className={styles.devHint}>{devHintLabel}</div>
        )}
        {!isFrame && (<HeaderSection />)}
        <RatingSection />
        {!isFrame && (<FooterSection />)}
      </div>
    </RatingContext.Provider>
  )
}

export default App
